<template>
	<div class="wrapper">
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs12 sm12 md3>
					<v-select
						persistent-hint
						hint="Select File Extension"
						color="yellow darken-3"
						:items="fileExtensions"
						label="File Extensions"
						v-model="extension"
					></v-select>
				</v-flex>
				<v-flex xs12 sm12 md5>
					<v-text-field
						persistent-hint
						hint="Enter Text to Filter by"
						color="yellow darken-3"
						label="Filter Text"
						v-model="filterText"
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs6 sm6 md3>
					<v-btn @click="filterStockist" flat color="orange darken-1" large
						>Filter</v-btn
					>
				</v-flex>
				<v-flex xs6 sm6 md3 @click="refreshStockistList">
					<v-btn color="pink" flat>Reset Filter</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
		<code>No. of files: {{ getFileCount }}</code>
		<v-expansion-panel>
			<v-expansion-panel-content
				v-for="item of Object.keys(mailMeta)"
				:key="item"
			>
				<template v-slot:header>
					<div class="font-weight-light pa-2">
						<span class="headline"
							>Stockist Name: -
							{{
								mailMeta[item][0] ? mailMeta[item][0].stockistName : ''
							}}</span
						>
						<br />
						<span class="subheader" @click.right.prevent="copyToClipboard(item)"
							>Stockist Code: - {{ item }}</span
						>
						<br />
						<span class="subheader">Files: - {{ mailMeta[item].length }}</span>
					</div>
				</template>
				<v-card flat>
					<v-card-text>
						<v-list two-line subheader>
							<v-list-tile
								v-for="file in mailMeta[item]"
								:key="file._id"
								@click="openFileMetaModal(file)"
							>
								<v-list-tile-action>
									<v-icon :color="file.discovery ? 'blue darken-1' : 'black'"
										>attach_file</v-icon
									>
								</v-list-tile-action>
								<v-list-tile-content>
									<v-list-tile-title>
										<span @click.right.prevent="copyFileNameToClipboard(file.filename)">
											File name: - {{ file.filename }}
										</span>
									</v-list-tile-title>
									<v-list-tile-sub-title
										>Original file name: -
										{{ file.originalFilename }}</v-list-tile-sub-title
									>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-icon>keyboard_arrow_right</v-icon>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
					</v-card-text>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<div class="mt-1 mb-1 text-xs-center">
			<v-pagination
				color="yellow darken-3"
				prev-icon="navigate_before"
				next-icon="navigate_next"
				v-model="page"
				:total-visible="5"
				:length="paginationLength"
				@input="updatePage"
			></v-pagination>
		</div>
		<v-btn
			@click="refreshStockistList"
			color="pink"
			fab
			dark
			fixed
			small
			bottom
			right
		>
			<v-icon>autorenew</v-icon>
		</v-btn>
		<FileMetaModal v-if="fileMetaEditorDialog" />
	</div>
</template>

<script>
import FileMetaModal from './fileMetaModal';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import clipboardCopyMixin from '@/mixins/clipboardCopyMixin';

export default {
	mixins: [clipboardCopyMixin],
	data() {
		return {
			page: 1,
			paginationLength: 10,
			filterText: '',
			extension: false,
			fileExtensions: [
				{ text: 'All', value: false },
				...require('../../components/extensions.json'),
			],
		};
	},
	components: {
		FileMetaModal,
	},
	created() {
		this.fetchMailMeta();
	},
	methods: {
		...mapActions('extractedData', ['getMailMeta']),
		...mapMutations('extractedData', ['openFileMetaDialog', 'setSelectedFile']),
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog']),
		openFileMetaModal(item) {
			this.setSelectedFile(item);
			this.openFileMetaDialog();
		},
		fetchMailMeta() {
			this.openLoaderDialog();
			this.getMailMeta({
				pageNo: this.page,
				pageSize: 20,
				text: this.filterText,
				extension: this.extension,
				...this.getSelectedDates,
			}).then(data => {
				this.closeLoaderDialog();
				if (data) {
					// console.log(data);
					this.paginationLength = Math.ceil(data.length / 20);
					console.log('Loaded mail meta');
				} else {
					console.log('Failed to load mail meta');
				}
			});
		},
		refreshStockistList() {
			this.page = 1;
			(this.filterText = ''), (this.extension = false), this.fetchMailMeta();
		},
		updatePage() {
			this.fetchMailMeta();
		},
		filterStockist() {
			this.fetchMailMeta();
		},
	},
	computed: {
		...mapGetters(['getSelectedDates', 'selectedDates']),
		...mapGetters('extractedData', ['fileMetaEditorDialog', 'mailMeta']),
		getFileCount() {
			let count = 0;
			for (let i in this.mailMeta) {
				count += this.mailMeta[i].length;
			}
			return count;
		},
	},
	mounted() {
		this.$store.subscribe((mutation, state) => {
			if (mutation.type === 'extractedData/refreshStockistListEmitter') {
				this.refreshStockistList();
			}
		});
	},
	watch: {
		selectedDates(nv, cv) {
			// console.log(nv, cv);
			this.refreshStockistList();
		},
	},
};
</script>

<style lang="scss" scoped>
.v-pagination >>> li button {
	width: 100%;
	min-width: 35px;
}
.v-card__text {
	padding: 0px;
}
</style>
